import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DesktopMenu from "../../common/DesktopMenu/index";
import MobileMenu from "../../common/MobileMenu/index";
import useWindowSize from "../../common/windowSize";
import NewFooter from "../../common/NewFooter";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { toast } from "react-toastify";
import { publicAPI } from "../../utils/api";
import { useTranslation } from "react-i18next";
import {
  Background,
  AllGroupWrapper,
  GroupWrapper,
  GroupTitle,
} from "./styles";

const Shop = () => {
  const size = useWindowSize();
  const [mobileMenu, setMobileMenu] = useState(false);
  const [allGroups, setAllGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  const { i18n } = useTranslation();
  var language = i18n.language;

  const getAllGroups = async () => {
    setLoading(true);

    try {
      const response = await publicAPI.get(`/public/bacchus/productgroup`);
      setAllGroups(response.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (error.request.status === 500)
        return toast.error("Internal server error");
    }
  };

  useEffect(() => {
    getAllGroups();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (size.width < 1200) {
      setMobileMenu(true);
    } else {
      setMobileMenu(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [size]);

  return (
    <>
      <Background>
        {mobileMenu ? <MobileMenu /> : <DesktopMenu />}
        <AllGroupWrapper>
          {allGroups.length
            && allGroups.map((item) => (
                <GroupWrapper key={`${item.id}_${item.name}`}>
                  <Link to={`/group/${item.id}`}>
                    <img
                      src={item.image}
                      alt={item.name}
                      style={{
                        width: "100%",
                        maxWidth: "800px",
                      }}
                    />
                    <GroupTitle>
                      {language === "en"
                        ? item.name
                        : language === "fr"
                        ? item.name_fr
                        : language === "de"
                        ? item.name_de
                        : language === "it"
                        ? item.name_it
                        : item.name}
                    </GroupTitle>
                    <div></div>
                    {/* <GroupDescription>
                      {language === "en"
                        ? item.description
                        : language === "fr"
                        ? item.description_fr
                        : language === "de"
                        ? item.description_de
                        : language === "it"
                        ? item.description_it
                        : item.description}
                    </GroupDescription> */}
                  </Link>
                </GroupWrapper>
              ))
            }
        </AllGroupWrapper>
      </Background>
      <NewFooter />
      <Backdrop sx={{ color: "#fff", zIndex: 1000 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default Shop;
